export default "__VITE_ASSET__16b4ec55__"